export default {
  login: {
    email: "Email",
    password: "Password",
    login: "Login",
    forgot: "Forgot Password"
  },
  app: {
    hello: "Hello",
    hello_description: `Scientists have shown that mood and sleep can affect cognitive performance. Record this data so you can track your own trends.`,
    howareu: "How are you today?",
    sleep: "How long did you sleep?",
    save: "Save",
    five: "5 or less",
    nine: "9 or above",
    cokkotu: "Too bad",
    kotu: "Bad",
    idareeder: "Not too bad",
    good: "Good",
    super: "Super!"
  },
  header: {
    tests: "Tests",
    logout: "Logout",
    home: "HOME",
    education: "TRAININGS",
    exercises: "EXERCISES"
  },
  pause: {
    paused: "Paused",
    continue: "Click to continue"
  },
  coursedetail: {
    step: "Exercise",
    second: "second",
    start: "START",
    confirm:
      "The exercise is not finished yet, if you exit, the data of this exercise will not be saved.",
    done: "You Have Finished Today's Exercises."
  },
  courses: {
    courses: "Trainings",
    description: `With this training specially defined for you;<br />
    - It will train your eye muscles,<br />
    -It will make your eyes see agile<br />
    - It will expand your field of vision,<br />
    - Rhythm faster and more effectively with your eyes on the lines
    will win<br />
    Thus, you will read faster by providing vision + perception harmony.`,
    total_day: "Total Course Duration:",
    finished_day: "Finished Day: {day}",
    day: "Day",
    canrepeat: "There are repeatable {day} days and {exercise} exercises.",
    repeat: "Repeat",
    repeat_step: "Day {step}",
    start_repeat: "Start Repeat",
    continue_repeat: "Continue Repeat",
    start: "Start"
  },
  edetail: {
    start: "START"
  },
  e: {
    welcome: "Welcome to the Exercises",
    description: `You can start by choosing any type of exercise you need and need for speed reading development.`
  },
  cats: {
    "Göz Egzersizleri": "Eye Exercises",
    "Dikkat & Odaklanma": "Attention and Focus",
    Hız: "Speed",
    Hafıza: "Memory",
    "Okuma & Anlama": "Reading & Understanding",
    test: "Reading Speed Test",
    "Zihinsel Matematik": "Mental Mathematics"
  },
  module: {
    start: "START",
    speed: "SPEED",
    object_count: "NUMBER OF OBJECTS",
    direction: "AXIS",
    eksen: "AXIS",
    horizontal: "HORIZONTAL",
    vertical: "VERTICAL",
    autolevel: "AUTO INCREASE",
    yes: "YES",
    no: "NO",
    time: "TIME",
    level: "LEVEL",
    rows: "ROWS",
    cols: "COLS",
    benzerkelimeler: {
      description: "Mark blocks with different words"
    },
    read_speed: "Reading Speed:",
    wordperminute: "Words/Minute",
    start_again: "Start Again",
    charlevel: "CHARACTER LEVEL",
    screenwidth: "SCREEN WIDTH",
    screenheight: "SCREEN HEIGHT",
    short: "SHORT",
    mid: "MIDDLE",
    long: "LONG",
    cevrefokus: {
      description: "Write down the word(s) you see on the screen."
    },
    group: "GROUP & NOT GROUP",
    same: "SAME & NOT SAME",
    mode: "MODE",
    isgroup: "GROUP",
    issame: "SAME",
    isnotgroup: "NOT GROUP",
    isnotsame: "NOT SAME",
    level_completed: "Chapter Completed",
    point: "Your score:",
    continue: "Continue",
    show_time: "APPEAR TIME",
    farkliolan: {
      description: "Tick the characters that break the slice"
    },
    showing_word: "HIGHLIGHTED WORD",
    marquee: "SCROLLING TEXT",
    start_again: "Start Again",
    read_speed: "Your Reading Speed: {speed} words/minute",
    attention: "ATTENTION MODE",
    open: "OPEN",
    close: "CLOSED",
    image: "IMAGE",
    gozesnetme: {
      description: `During {seconds} seconds, you need to count how many times the above figure appears<br /><br />`,
      question: `<br />
      How many times have you seen the figure above<br />?<br /><br />`
    },
    grupokuma: {
      level: "Implicit {level} Word",
      marquee: "SCROLLING TEXT"
    },
    finished: "Finished",
    hafiza: {
      des1: "Keep Colored Squares in Mind",
      des2: "Mark the Squares"
    },
    point: "Point",
    level: "Level",
    total_true: "Total Correct",
    total_false: "Total Incorrect:",
    isabet: "Hit Rate:",
    reaction: "Reaction Time Per Shape:",
    seconds: "second",
    start_again: "Start Again",
    hafizandatut: {
      desc: "Is the card on the screen<br />same as the previous card?<br />"
    },
    time: "Duration",
    different: "Different",
    same: "SWhich Is Bigger?ame",
    which_bigger: "Hangisi Daha Büyük?",
    timeisend: `The time is over<br />
    Point: {point}<br />`,
    left: "Left",
    allsame: "Both the same",
    right: "Right",
    view_time: "APPEAR TIME",
    letter_count: "NUMBER OF LETTERS",
    harfsayma: {
      description: `How many {currentLetter} are there?`
    },
    hizlisecim: {
      description:
        "Is the shape and color on the screen<br />the same as the previous shape and color?<br />",
      different: "Different",
      same: "Same"
    },
    text_length: "TEXT LENGTH",
    kelimeavi: {
      description: 'Find the word(s) "{currentLetter}" in the reading text'
    },
    siralama: {
      desc: `Sharpen your field of view and build the tallest tower. Press the numbers that will appear in the boxes in order from smallest to largest.`,
      start: "Got it, we can get started!",
      starat: "Got it, we can get started!"
    },
    tak: {
      placeholder: "Write down the word(s) you see on the screen."
    },
    zikzak: {
      desc: `<br />
      How many times have you seen the color above<br />?<br /><br />`,
      dikkat: `<br />
      <br />how many<br />the color above for {time} seconds
      You need to count the times you have appeared<br /><br />`
    }
  },
  home: {
    exercises: "My Exercises",
    welcome: "Welcome",
    stats: "Reading Speed Statistics",
    last_speed: "Last Read Rate",
    last_under: "Last Understanding Rate",
    first_speed: "First Read Speed",
    first_under: "First Comprehension Rate",
    gain: "Development Status",
    read: {
      title: "Before We Begin, We Need to Measure Reading Speed",
      desc: `We will have you read a short text and ask short questions about the text you are reading. This test will help us determine your reading speed.`,
      start: "Start Test"
    },
    kdk: " w/m",
    reading_speed: "Reading Speed",
    unders: "Understanding Ratio"
  },
  modules: {
    "Göz Kasları Esnetme": "Eye Muscle Stretch",
    "İkili & Üçlü Kolon": "Double & Triple Column",
    "Görme Alanı": "Visual Field",
    "Göz Ritmi": "Eye Rhythm",
    "Sıralı Nesneler": "Ordered Objects",
    "Say Bakalım": "Let's see",
    "Farkı Bul": "Find the Difference",
    "Kelime Avı": "Word Hunt",
    Takistoskop: "Tachistoscope",
    "Çoklu Odak": "Multi Focus",
    "Çevre Fokus": "Environmental Focus",
    "Blok Okuma": "Block Reading",
    Gölgeleme: "Shading",
    Gruplama: "Grouping",
    ZikZak: "Zigzag",
    "Genis Bakış": "Wide View",
    "Düzelt Bakalım": "Let's fix it",
    "Kelime Yeterliliği": "Vocabulary",
    "Benzer Kelimeler": "Similar Words",
    "Hangisi Büyük?": "Which is big?",
    Video: "Video",
    "Hızlı Seçim": "Quick Selection",
    "Köstebeği Yakala": "Catch the Mole",
    "Hafıza Üçgeni": "Memory Triangle",
    "Hafıza Kareleri": "Memory Squares",
    "Dönen Hafıza": "Rotating Memory",
    "Hız Üçgeni": "Speed Triangle"
  },
  speedtest: {
    title: "Welcome to the speed test",
    description:
      "When you click the button below, the time will start. If you're ready, let's start!",
    start: "Start",
    speed: "Your reading speed",
    kd: "Words/Minute",
    time: "Elapsed time {time} seconds",
    desc2:
      "If you think that you have read the text with understanding, you can move on to questions about the text.",
    hatirlatma:
      "We would like to remind you that if your comprehension level is below 50%, you will need to repeat this text.",
    sorularagec: "go to questions",
    metnedon: "back to text",
    hesaplamatamam: "Calculation complete",
    anlamaorani: "Comprehension Rate",
    geri: "Back",
    hesapla: "Calculate",
    bitti: "Finish"
  },
  golge: {
    mode_1: "Wipe Shading",
    mode_2: "Shading without Erasing",
    mode_3: "Read Shading",
    mode_4: "Typing Shading"
  }
};



// WEBPACK FOOTER //
// ./src/languages/en.js